import Alt from '../alt';
import {registerLocalizationStore} from 'epic-react-common/src/stores/LocalizationStore';

export default registerLocalizationStore(Alt);
